mutation SetYouTubeDemoExempt($email: String!, $exempt: Boolean!) {
  result: StreamToolsSetYouTubeDemoExempt(email: $email, exempt: $exempt) {
    accountId
    youtubeDemoExempt
  }
}
